<template>
  <InvoiceNav />
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:table-heading>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #s/n
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Patient Name
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        OPD/IPD
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Phone Contact
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Visit Date
      </th>
      <th class="text-secondary opacity-7"></th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div></div>
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-sm">{{ user.name }}</h6>
              <p class="text-xs text-secondary mb-0">
                {{ user.email == null ? "--" : user.email }}
              </p>
            </div>
          </div>
        </td>
        <td>
          <p class="text-xs font-weight-bold mb-0">
            OPD/{{ user.opd == null ? "--" : user.opd }}
          </p>
          <p class="text-xs text-secondary mb-0">
            IPD/{{ user.ipd == null ? "--" : user.ipd }}
          </p>
        </td>
        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">{{
            user.phone == null ? "---" : user.phone
          }}</soft-badge>
        </td>
        <td class="align-middle text-center text-sm">
          <p>{{ formatDateTime1(user.created_at) }}</p>
        </td>
        <td class="align-middle">
          <a
            :href="'/invoices/invoiceDetail/' + user.id"
            style="
              border: 1px solid black;
              padding: 4px;
              color: green;
              font-weight: bold;
            "
            data-toggle="tooltip"
            data-original-title="Edit user"
          >
            Show Invoice
          </a>
        </td>
      </tr>
    </template>
  </BaseLayout>
</template>

<script>
// import { generalApiRequest } from "../../api/apiIndex.js";
// import Pagination from '../components/pagination.vue';
import InvoiceNav from "./invoice_nav.vue";
import BaseLayout from "../../Patients/components/table_page_layout.vue";
import formatDateTime from "../../../timezone/utc_local_time";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      // visit_id: this.$route.params.storeLocation,
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: "get_all_gp_invoices_queue_search",
      mainUrl: "get_all_gp_invoices_queue",
      showIssuePrescriptionModal: false,
    };
  },
  components: {
    BaseLayout,
    InvoiceNav,
    // IssuePrescriptionModal,

    // Search
  },

  methods: {
    handle_external_mount(payload) {
      this.users = payload;
      console.log(this.users);
    },
    showIssuePrescription() {
      this.showIssuePrescriptionModal = true;
    },
    closePresMod() {
      this.showIssuePrescriptionModal = false;
    },

    formatDateTime1(datetime) {
      return formatDateTime(datetime);
    },
  },

  mounted() {
    // this.callApi();
  },
};
</script>

<style scoped>
/* Remove all margins, paddings, and spacing from the table and its elements */
.table {
  margin: 0 !important;
  padding: 0 !important;
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  width: 100%;
}

.table th,
.table td,
.table tr,
.table thead,
.table tbody {
  margin: 0 !important;
  padding: 0 !important;
  /* border: none !important; */
  vertical-align: middle;
}

/* Optional: tighten up text spacing */
.table th,
.table td {
  font-size: 0.85em;
  line-height: 1.2em;
}

/* Optional: keep header text readable */
.table thead th {
  background-color: #f8f9fa;
  font-weight: 600;
}
</style>
